import React from 'react'

const Divider = ({ className, text }) => (
  <div className={`flex items-center ${className}`}>
    <div className="w-full h-0.5 bg-gray-200 rounded" />
    <div className="text-gray-400 whitespace-nowrap text-center mx-2">
      {text}
    </div>
    <div className="w-full h-0.5 bg-gray-200 rounded" />
  </div>
)

export default Divider
